var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { EventsService } from "app/lib/EventsService";
import { BaseComponent } from "app/views/base.component";
import { NotificationsService } from 'angular2-notifications';
import { UserService } from "../user.service";
var LiveComponent = /** @class */ (function (_super) {
    __extends(LiveComponent, _super);
    function LiveComponent(activatedRoute, translate, filter, eventsService, notifications, userService) {
        var _this = _super.call(this, eventsService, userService, activatedRoute, filter, translate) || this;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.filter = filter;
        _this.eventsService = eventsService;
        _this.notifications = notifications;
        _this.userService = userService;
        _this.listLoader = false;
        _this.userRegSource = '';
        _this.timerId = null;
        return _this;
    }
    LiveComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getList()];
                    case 1:
                        _a.sent();
                        this.setTimer();
                        return [2 /*return*/];
                }
            });
        });
    };
    LiveComponent.prototype.getList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.rows = [];
                        if (this.timerId) {
                            clearInterval(this.timerId);
                        }
                        this.listLoader = true;
                        return [4 /*yield*/, this.userService.userLive.stats({
                                userRegSource: this.userRegSource,
                                lang: '',
                                paidType: '',
                            }).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        this.rows = stats;
                        this.rows.reverse();
                        this.listLoader = false;
                        this.showInfo(this.rows.length, 0);
                        return [2 /*return*/];
                }
            });
        });
    };
    LiveComponent.prototype.setTimer = function () {
        var me = this;
        me.timerId = setTimeout(function () {
            return __awaiter(this, void 0, void 0, function () {
                var addedCount, changedCount, stats, _loop_1, _i, stats_1, rowNew;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (me.timerId) {
                                clearInterval(me.timerId);
                            }
                            addedCount = 0;
                            changedCount = 0;
                            return [4 /*yield*/, me.userService.userLive.stats({
                                    userRegSource: me.userRegSource,
                                    lang: '',
                                    paidType: '',
                                }).toPromise()];
                        case 1:
                            stats = (_a.sent()).stats;
                            stats.reverse();
                            _loop_1 = function (rowNew) {
                                var user = me.rows.reduce(function (pre, cur) {
                                    return cur._id == rowNew._id ? cur : pre;
                                }, null);
                                if (user == null) {
                                    addedCount++;
                                    me.rows.unshift(rowNew);
                                }
                                else {
                                    if (rowNew.firstSiteDomain && rowNew.firstSiteDomain != user.firstSiteDomain) {
                                        changedCount++;
                                        user.firstSiteDomain = rowNew.firstSiteDomain;
                                        user.isUpdated = true;
                                    }
                                }
                            };
                            for (_i = 0, stats_1 = stats; _i < stats_1.length; _i++) {
                                rowNew = stats_1[_i];
                                _loop_1(rowNew);
                            }
                            if (addedCount > 0 || changedCount > 0) {
                                me.showInfo(addedCount, changedCount);
                            }
                            me.setTimer();
                            return [2 /*return*/];
                    }
                });
            });
        }, 30 * 1000);
    };
    LiveComponent.prototype.showInfo = function (added, changed) {
        this.notifications.info('Пользователей', "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043E: " + added + "; \u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u043E: " + changed, { timeOut: 4000 });
    };
    LiveComponent.prototype.ngOnDestroy = function () {
        clearTimeout(this.timerId);
        _super.prototype.ngOnDestroy.call(this);
    };
    return LiveComponent;
}(BaseComponent));
export { LiveComponent };
